import axios from "../services/api/api";

export const FETCH_NOTIFICATIONS_BEGIN = "FETCH_NOTIFICATIONS_BEGIN";
export const FETCH_NOTIFICATIONS_FULFILLED = "FETCH_NOTIFICATIONS_FULFILLED";
export const FETCH_NOTIFICATIONS_REJECTED = "FETCH_NOTIFICATIONS_REJECTED";
export const POST_NOTIFICATION_READ_STATUS_BEGIN =
  "POST_NOTIFICATION_READ_STATUS_BEGIN";
export const POST_NOTIFICATION_READ_STATUS_FULFILLED =
  "POST_NOTIFICATION_READ_STATUS_FULFILLED";
export const POST_NOTIFICATION_READ_ALL_STATUS_FULFILLED =
  "POST_NOTIFICATION_READ_ALL_STATUS_FULFILLED";
export const POST_NOTIFICATION_READ_STATUS_REJECTED =
  "POST_NOTIFICATION_READ_STATUS_REJECTED";
export const DELETE_NOTIFICATION_BEGIN = "DELETE_NOTIFICATION_BEGIN";
export const DELETE_NOTIFICATION_FULFILLED = "DELETE_NOTIFICATION_FULFILLED";
export const DELETE_NOTIFICATION_REJECTED = "DELETE_NOTIFICATION_REJECTED";

export function fetchNotifications(data) {
  return (dispatch) => {
    dispatch({
      type: FETCH_NOTIFICATIONS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .get(`/User/GetNotices`)
        .then((response) => {
          dispatch({
            type: FETCH_NOTIFICATIONS_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_NOTIFICATIONS_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export function postNotificationRead(notificationId, read) {
  return (dispatch) => {
    dispatch({
      type: POST_NOTIFICATION_READ_STATUS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .post(`/User/SetNoticeToRead?noticeId=${notificationId}`)
        .then(() => {
          dispatch({
            type: POST_NOTIFICATION_READ_STATUS_FULFILLED,
            payload: {
              id: notificationId,
              read: true,
            },
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_NOTIFICATIONS_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export function postSetNotificationsToRead(noticeIds) {
  return (dispatch) => {
    dispatch({
      type: POST_NOTIFICATION_READ_STATUS_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .post(`/User/SetNoticesToRead`, { ids: noticeIds })
        .then((res) => {
          dispatch({
            type: POST_NOTIFICATION_READ_ALL_STATUS_FULFILLED,
            payload: res.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_NOTIFICATIONS_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export function toggleDeleteNotification(notificationData) {
  return (dispatch) => {
    dispatch({
      type: DELETE_NOTIFICATION_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/User/SetNoticeDeletedStatus?noticeId=${notificationData.notificationId}&isDeleted=${notificationData.isDeleted}`
        )
        .then((response) => {
          dispatch({
            type: DELETE_NOTIFICATION_FULFILLED,
            payload: {
              id: notificationData.notificationId,
              isDeleted: notificationData.isDeleted,
            },
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: DELETE_NOTIFICATION_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}
